module.exports = __webpack_public_path__ + "img/ST.60eccf73.svg";